import type { Prisma as PrismaTypes } from "encamp-prisma/generated/client";

import { Prisma } from "encamp-prisma/generated/browser";

export function parseAuditDecimal(value: string | null | undefined): PrismaTypes.Decimal | null {
  if (value == null || value.trim() === "") return null;
  try {
    const decimal = new Prisma.Decimal(value);
    return decimal.isFinite() ? decimal : null;
  } catch {
    return null;
  }
}
